
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-08deff6e!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PercentOfTotalComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PercentOfTotalComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-08deff6e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PercentOfTotalComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/PercentOfTotalComponent.vue
// module id = 229
// module chunks = 2